import { render, staticRenderFns } from "./submission-deadline.vue?vue&type=template&id=748eb388&"
import script from "./submission-deadline.vue?vue&type=script&lang=js&"
export * from "./submission-deadline.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports